import { useEffect, useState } from "react";
import { CurrentsAPI, type OceanOrgMemory } from "@vida/currents-core";
import { createCurrentsApiConfig } from "../services/currentsSession";

export function MemoriesCatalogPage() {
  const [items, setItems] = useState<OceanOrgMemory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const memories = await CurrentsAPI.listOrgMemories(createCurrentsApiConfig(), undefined, false);
        setItems(memories);
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Memorie</h1>
          <p className="muted">Contesti persistenti condivisi — ogni agente seleziona quali usare.</p>
        </div>
      </header>

      {loading && <p className="muted">Caricamento…</p>}
      {error && <p className="err">{error}</p>}

      {!loading && !error && items.length === 0 && (
        <div className="card">
          <p className="muted">Nessuna memoria nel catalogo.</p>
        </div>
      )}

      {!loading && !error && items.length > 0 && (
        <div className="catalog-grid">
          {items.map((m) => (
            <article key={m.id} className="catalog-card">
              <div className="catalog-card-head">
                <span className="catalog-icon" aria-hidden>
                  🧠
                </span>
                <div>
                  <h2>{m.name}</h2>
                  <code className="catalog-id">{m.id}</code>
                </div>
              </div>
              {m.description && <p className="muted">{m.description}</p>}
              <p className="catalog-meta">
                <span className="chip">{m.scope}</span>
                <span className="chip">{m.enabled ? "Attiva" : "Disabilitata"}</span>
              </p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
